// extracted by mini-css-extract-plugin
export default {"form":"Entry_form__s+jta","control":"Entry_control__Cu39t","actions":"Entry_actions__xv-MV"};